/* The Lips Clinic: comportamiento del sitio (carruseles, índice de secciones y reserva online). */
(function () {
  'use strict';

  var reduceMotion = function () {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  /* Carrusel de tarjetas: flechas y contador en móvil. */
  function initCarousel(root) {
    var track = root.firstElementChild;
    var controls = root.querySelector('.carousel-controls');
    if (!track || !controls) return;
    var buttons = controls.querySelectorAll('button');
    var prev = buttons[0];
    var next = buttons[1];
    var counter = controls.querySelector('span');
    var total = track.children.length;

    var step = function () {
      var first = track.firstElementChild;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return (first ? first.getBoundingClientRect().width : 0) + gap;
    };

    var update = function () {
      var last = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      var index = last ? total - 1 : Math.min(total - 1, Math.round(track.scrollLeft / Math.max(1, step())));
      counter.textContent = index + 1 + ' / ' + total;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = last;
    };

    var go = function (dir) {
      track.scrollBy({ left: dir * step(), behavior: reduceMotion() ? 'auto' : 'smooth' });
    };

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    update();
  }

  /* Índice de secciones: marca la sección visible. */
  function initIndex(nav) {
    var links = nav.querySelectorAll('a[href^="#"]');
    if (!links.length || !('IntersectionObserver' in window)) return;
    var byId = {};
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          links.forEach(function (link) { link.removeAttribute('aria-current'); });
          var active = byId[entry.target.id];
          if (active) active.setAttribute('aria-current', 'true');
        });
      },
      { rootMargin: '-45% 0px -50% 0px' }
    );
    links.forEach(function (link) {
      var id = decodeURIComponent(link.getAttribute('href').slice(1));
      var target = document.getElementById(id);
      if (!target) return;
      byId[id] = link;
      observer.observe(target);
    });
  }

  /* Selector de día y hora con las horas libres del Google Calendar de la doctora (Apps Script). */
  function createSlotPicker(box, root) {
    var agenda = box.getAttribute('data-agenda');
    var daysEl = box.querySelector('[data-slot-days]');
    var timesEl = box.querySelector('[data-slot-times]');
    var status = box.querySelector('[data-slot-status]');
    var prev = box.querySelector('[data-slot-prev]');
    var next = box.querySelector('[data-slot-next]');
    var token = Math.random().toString(36).slice(2) + Date.now().toString(36);
    var cache = {};
    var duration = 60;
    var picked = null;
    var request = 0;
    var zone = 'America/Santiago';

    var noon = function (fecha) { return new Date(fecha + 'T15:00:00Z'); };
    var fmt = function (fecha, opts) {
      opts.timeZone = zone;
      return new Intl.DateTimeFormat('es-CL', opts).format(noon(fecha)).replace('.', '');
    };
    var say = function (text) { status.textContent = text || ''; status.hidden = !text; };

    var updateArrows = function () {
      prev.disabled = daysEl.scrollLeft <= 2;
      next.disabled = daysEl.scrollLeft >= daysEl.scrollWidth - daysEl.clientWidth - 2;
    };
    var scrollDays = function (dir) {
      daysEl.scrollBy({ left: dir * daysEl.clientWidth * 0.8, behavior: reduceMotion() ? 'auto' : 'smooth' });
    };
    prev.addEventListener('click', function () { scrollDays(-1); });
    next.addEventListener('click', function () { scrollDays(1); });
    daysEl.addEventListener('scroll', updateArrows, { passive: true });

    var showTimes = function (day) {
      timesEl.textContent = '';
      day.horas.forEach(function (hora) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'chip';
        b.textContent = hora;
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () {
          timesEl.querySelectorAll('.chip').forEach(function (c) { c.setAttribute('aria-pressed', c === b ? 'true' : 'false'); });
          picked = {
            fecha: day.fecha,
            hora: hora,
            duracion: duration,
            label: fmt(day.fecha, { weekday: 'long', day: 'numeric', month: 'long' }).replace(',', '') + ', ' + hora
          };
          say('');
        });
        timesEl.appendChild(b);
      });
    };

    var render = function (dias, message) {
      daysEl.textContent = '';
      timesEl.textContent = '';
      picked = null;
      if (!dias.length) {
        say(root.getAttribute('data-slots-empty'));
        updateArrows();
        return;
      }
      say(message || '');
      dias.forEach(function (day, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'chip';
        b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
        b.innerHTML = '<span></span><small></small>';
        b.firstChild.textContent = fmt(day.fecha, { weekday: 'short', day: 'numeric' });
        b.lastChild.textContent = fmt(day.fecha, { month: 'short' });
        b.setAttribute('aria-label', fmt(day.fecha, { weekday: 'long', day: 'numeric', month: 'long' }));
        b.addEventListener('click', function () {
          daysEl.querySelectorAll('.chip').forEach(function (c) { c.setAttribute('aria-pressed', c === b ? 'true' : 'false'); });
          picked = null;
          showTimes(day);
        });
        daysEl.appendChild(b);
      });
      daysEl.scrollLeft = 0;
      showTimes(dias[0]);
      updateArrows();
    };

    /* Si la agenda no responde, vuelve al campo de texto libre para no perder la reserva. */
    var fallback = function () {
      box.querySelector('.slot-row').hidden = true;
      timesEl.textContent = '';
      if (!box.querySelector('input[name="properties[Día u horario preferido]"]')) {
        var label = document.createElement('label');
        label.textContent = 'Día u horario preferido';
        var input = document.createElement('input');
        input.name = 'properties[Día u horario preferido]';
        input.placeholder = 'Ej: martes en la tarde';
        label.appendChild(input);
        box.insertBefore(label, status);
      }
      say(root.getAttribute('data-slots-error'));
      box.removeAttribute('data-ready');
    };

    var load = function (minutes, force, message) {
      duration = minutes;
      var id = ++request;
      if (cache[minutes] && !force) return render(cache[minutes]);
      daysEl.textContent = '';
      timesEl.textContent = '';
      picked = null;
      say(box.getAttribute('data-loading') || status.textContent);
      // Apps Script a veces tarda; pasados 15 s se reserva con el campo de texto libre.
      var stop = new AbortController();
      var timer = setTimeout(function () { stop.abort(); }, 15000);
      fetch(agenda + '?accion=horas&duracion=' + minutes + '&token=' + token, { signal: stop.signal })
        .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
        .then(function (data) {
          clearTimeout(timer);
          if (id !== request) return;
          cache[minutes] = data.dias || [];
          box.setAttribute('data-ready', '');
          render(cache[minutes], message);
        })
        .catch(function () { clearTimeout(timer); if (id === request) fallback(); });
    };
    box.setAttribute('data-loading', status.textContent);

    return {
      load: load,
      active: function () { return box.hasAttribute('data-ready'); },
      selected: function () { return picked; },
      ask: function () {
        say(root.getAttribute('data-slots-pick'));
        (daysEl.querySelector('[aria-pressed="true"]') || daysEl).focus();
      },
      /* Guarda la hora 15 min mientras se paga. Solo bloquea si la agenda confirma que se tomó;
         si tarda más de 8 s se sigue al pago igual (la cita se crea al pagarse). */
      hold: function () {
        var stop = new AbortController();
        var timer = setTimeout(function () { stop.abort(); }, 8000);
        return fetch(agenda, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify({ accion: 'retener', fecha: picked.fecha, hora: picked.hora, duracion: picked.duracion, token: token }),
          signal: stop.signal
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data && data.ok === false && data.motivo === 'ocupada') {
              load(duration, true, root.getAttribute('data-slots-taken'));
              return false;
            }
            return true;
          })
          .catch(function () { return true; })
          .then(function (free) { clearTimeout(timer); return free; });
      }
    };
  }

  /* Duración del servicio en minutos a partir del texto ("1 h 15 min", "45 min"). */
  function minutesOf(text) {
    var h = /(\d+)\s*h/.exec(text || '');
    var m = /(\d+)\s*min/.exec(text || '');
    return (h ? Number(h[1]) * 60 : 0) + (m ? Number(m[1]) : 0) || 60;
  }

  /* Reserva online: filtros, selección de servicio y pago del abono en el checkout. */
  function initBooking(root) {
    var chips = root.querySelectorAll('.chip');
    var services = root.querySelectorAll('.svc');
    var form = root.querySelector('form');
    if (!form || !services.length) return;
    var pickedName = form.querySelector('[data-picked-name]');
    var pickedMeta = form.querySelector('[data-picked-meta]');
    var depositNote = form.querySelector('[data-deposit-note]');
    var evalSlug = form.getAttribute('data-eval-slug');
    var email = root.getAttribute('data-email');
    var deposit = root.getAttribute('data-deposit');
    var selected = services[0];

    var variantInput = form.querySelector('[data-variant-input]');
    var slotsBox = form.querySelector('[data-slots]');
    var picker = slotsBox ? createSlotPicker(slotsBox, root) : null;

    var select = function (svc) {
      var changed = selected !== svc;
      selected = svc;
      if (variantInput) variantInput.value = svc.dataset.variant || '';
      if (picker && (changed || !picker.active())) picker.load(minutesOf(svc.dataset.duration));
      services.forEach(function (s) { s.setAttribute('aria-pressed', s === svc ? 'true' : 'false'); });
      pickedName.textContent = svc.dataset.name;
      pickedMeta.textContent = svc.dataset.duration + ' · valor del procedimiento ' + svc.dataset.price;
      depositNote.textContent = svc.dataset.slug === evalSlug
        ? root.getAttribute('data-note-eval')
        : root.getAttribute('data-note-other');
    };

    var param = new URLSearchParams(window.location.search).get('servicio');
    var initial = null;
    services.forEach(function (svc) {
      if (param && svc.dataset.slug === param) initial = svc;
      svc.addEventListener('click', function () {
        select(svc);
        if (window.matchMedia('(max-width: 980px)').matches) {
          form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
    // Una sola consulta a la agenda al abrir: la del servicio de la URL o la del primero.
    if (initial) select(initial);
    else if (picker) picker.load(minutesOf(selected.dataset.duration));

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var category = chip.dataset.category;
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        services.forEach(function (svc) {
          svc.hidden = !(category === 'Todos' || svc.dataset.category === category);
        });
      });
    });

    /* Sin producto asignado: solicitud por correo, como en la web original. */
    var sendByEmail = function (data) {
      var lines = [
        'Hola, quiero agendar: ' + selected.dataset.name + ' (valor ' + selected.dataset.price + ').',
        'Entiendo que la reserva se hace con un abono de ' + deposit + '.',
        '',
        'Nombre: ' + data.get('properties[Nombre]'),
        'Teléfono: ' + data.get('properties[Teléfono]'),
        (picker && picker.selected() ? 'Día y hora: ' + picker.selected().label : 'Día u horario preferido: ' + (data.get('properties[Día u horario preferido]') || 'A convenir')),
        data.get('properties[Comentarios]') ? 'Comentarios: ' + data.get('properties[Comentarios]') : ''
      ].filter(function (line, i) { return line || i === 2; });
      window.location.assign(
        'mailto:' + email +
        '?subject=' + encodeURIComponent('Solicitud de hora: ' + selected.dataset.name) +
        '&body=' + encodeURIComponent(lines.join('\n'))
      );
    };

    var amount = function (text) {
      return parseInt(String(text).replace(/\D/g, ''), 10) || 0;
    };

    /* Abono al carrito (solo este servicio) y directo al checkout de Shopify. */
    var submit = form.querySelector('[data-submit]');
    var error = form.querySelector('[data-booking-error]');
    var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var data = new FormData(form);
      var variant = selected.dataset.variant;
      if (picker && picker.active() && !picker.selected()) return picker.ask();
      if (!variant) return sendByEmail(data);

      var slot = picker && picker.active() ? picker.selected() : null;
      var properties = {
        'Nombre': data.get('properties[Nombre]'),
        'Teléfono': data.get('properties[Teléfono]')
      };
      if (slot) {
        // Visible en el checkout y el pedido; los campos con _ los usa la agenda para crear la cita.
        properties['Día y hora'] = slot.label;
        properties._fecha = slot.fecha;
        properties._hora = slot.hora;
        properties._duracion = String(slot.duracion);
      } else {
        properties['Día u horario preferido'] = data.get('properties[Día u horario preferido]') || 'A convenir';
      }
      properties['Valor del procedimiento'] = selected.dataset.price;
      if (data.get('properties[Comentarios]')) properties['Comentarios'] = data.get('properties[Comentarios]');
      var balance = amount(selected.dataset.price) - amount(deposit);
      if (selected.dataset.slug !== evalSlug && balance > 0) {
        properties['Saldo a pagar en la clínica'] = '$' + balance.toLocaleString('es-CL');
      }

      submit.disabled = true;
      error.hidden = true;
      var post = function (path, body) {
        return fetch(root_url + path, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body || {})
        }).then(function (res) {
          if (!res.ok) throw new Error(res.status);
          return res.json();
        });
      };
      (slot ? picker.hold() : Promise.resolve(true))
        .then(function (free) {
          if (!free) throw new Error('taken');
          return post('cart/clear.js');
        })
        .then(function () {
          return post('cart/add.js', { items: [{ id: Number(variant), quantity: 1, properties: properties }] });
        })
        .then(function () {
          window.location.assign(root_url + 'checkout');
        })
        .catch(function (err) {
          submit.disabled = false;
          if (err && err.message === 'taken') return;
          error.hidden = false;
        });
    });
  }

  function init(scope) {
    scope.querySelectorAll('[data-lips-carousel]').forEach(initCarousel);
    scope.querySelectorAll('[data-lips-index]').forEach(initIndex);
    scope.querySelectorAll('[data-lips-booking]').forEach(initBooking);
  }

  init(document);

  /* Editor de temas: reinicia la sección al editarla. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
